import React from 'react';
import PropTypes from 'prop-types';

import Toast from "components/WMS/Toast";

import ValidationIcon from 'assets/img/validated.svg'

PickingValidationToast.propTypes = {
    message: PropTypes.element,
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func
};

function PickingValidationToast({message = null, open = false, handleClose = () => {}}) {
    if (message === null) {
        return null;
    }

    return (
        <Toast
            open={open}
            handleClose={handleClose}
            isDesktop={false}
            isTop={false}
            customTimeout={2000}
            icon={<img style={{height: '20px', width: '20px'}} src={ValidationIcon} alt={"delete-icon"}/>}
            title={message}
        />
    );
}

export default PickingValidationToast;
